import { GetServerSidePropsContext } from 'next';
import { QueryKey } from 'react-query';
import { dehydrate } from 'react-query/hydration';

import { IPages } from '~/lib/data-contract';
import { navigationResolver } from '~/templates/pages/utils/navigationResolver';

import { frameResolver } from './frameResolver';
import { ssrQueryClient } from './ssrQueryClient';
import { translationResolver } from './translationResolver';

export const getDehydratedState = async (page: IPages, context: GetServerSidePropsContext) => {
	const frameFetch = frameResolver(context, page);
	const navigationFetch = navigationResolver(context, page);
	const translationFetch = translationResolver(context, page);

	await Promise.all([
		frameFetch.fetch(), // warm in parallel only when cache is cold
		navigationFetch.fetch(),
		translationFetch.fetch(),
	]);

	const allowedKeys = new Set<QueryKey>([frameFetch.queryKey, translationFetch.queryKey, navigationFetch.queryKey]);

	return dehydrate(ssrQueryClient, {
		shouldDehydrateQuery: (query) => allowedKeys.has(query.queryKey),
	});
};
